import GilaRiverData from "../../../../src/components/gila-river-data.js";
import * as React from 'react';
export default {
  GilaRiverData,
  React
};